import * as Yup from 'yup';
import { TabOption } from '../../../../shared/components/FormTabHeader';

export interface ICouponModel {
    id?: string
    status: string;
    ruleName: string;
    rentalStartDate?: string;
    rentalEndDate?: string;
    requestStartDate: string;
    requestEndDate: string;
    discount: number;
    promotionCode: string;
}



export const ValidationCoupon = Yup.object({
    status: Yup.string().required('Durum zorunlu'),
    ruleName: Yup.string().required('Kural adı zorunlu'),
    promotionCode: Yup.string().required('Promosyon kodu zorunlu'),
    discount: Yup.string().required('İskonto zorunlu'),
    rentalStartDate: Yup.string().required('Kira başlangıç tarihi zorunlu'),
    rentalEndDate: Yup.string().required('Kira bitiş tarihi zorunlu'),
    requestStartDate: Yup.string().required('Talep başlangıç tarihi zorunlu'),
    requestEndDate: Yup.string().required('Talep bitiş tarihi zorunlu')

});


export const initialCoupon: ICouponModel = {
    id: '',
    status: '',
    ruleName: '',
    rentalStartDate: '',
    rentalEndDate: '',
    requestStartDate: '',
    requestEndDate: '',
    discount: 0,
    promotionCode: '',
}

export const tabOptions: TabOption<'form'>[] = [
    { key: 'form', title: 'Promosyon Kodu', icon: 'bi bi-cash-coin' },

]
export const STATUS_OPTIONS = [
    { value: 'ACTIVE', label: 'Aktif' },
    { value: 'PASSIVE', label: 'Pasif' },

] as const